import { ExchangeRateList } from "@/modules/exchangeRate/components";
import type { ICurrencyExchangeTemplateForm } from "@/modules/template/common/types";
import { CurrencyExchangeTemplateForm } from "@/modules/template/components";
import { currencyExchangeTemplateValidationSchema } from "@/modules/template/validations";
import { CloudflareAsset, SideSheetPosition } from "@/shared/common/enums";
import type { IOperationPageProps } from "@/shared/common/types";
import { CloudFlareImage, PageHeader, } from "@/shared/components";
import { useMediaQuery, useTranslationExists } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { SideSheet } from "@ab.uitools/ui-library/components/SideSheet";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { useState } from "react";

export const CurrencyExchangeTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();
  const isDesktop = useMediaQuery();
  const [isCurrencySideBarOpen, setIsCurrencySideBarOpen] = useState<boolean>(false);

  const initialValues: ICurrencyExchangeTemplateForm = {
    creditAccount: "",
    debitAccount: "",
    amount: "",
    rate: "",
    purpose: "",
  };

  return (
    <>
      <FormContainer
        className="full-width page-container form-layout"
        formId="form-container"
        mode="onBlur"
        reValidateMode="onBlur"
        initialValues={initialValues}
        validationScheme={currencyExchangeTemplateValidationSchema({ t })}
      >
        <PageHeader>
          {!isCurrencySideBarOpen && (
            <>
              <Button
                type="secondary"
                size="small"
                className="ml-16 currencies-side-sheet-btn"
                data-testid="open-info-side-sheet"
                data-ga-id="open-info-side-sheet"
                data-ga-action="Open Currency exchange list side sheet"
                iconProps={{
                  Component: (props: ISVGIconProps) => (
                    <CloudFlareImage {...props} path={CloudflareAsset.Currencies}/>
                  ),
                  alignment: "left",
                }}
                onClick={() => {
                  setIsCurrencySideBarOpen(!isCurrencySideBarOpen);
                }}
              />
            </>
          )}
        </PageHeader>
        <CurrencyExchangeTemplateForm isEdit={isEdit}/>
      </FormContainer>
      <SideSheet
        position={isDesktop ? SideSheetPosition.Right : SideSheetPosition.Bottom}
        isPositioned={!isDesktop}
        withOverlay={!isDesktop}
        isWithDivider
        isOpen={isCurrencySideBarOpen}
        className="currencies-side-sheet"
        onClose={() => setIsCurrencySideBarOpen(false)}
        title={t("transfer.exchangeRateSidebarTitle")}
      >
        <div className="flexbox flex-wrap--wrap">
          <ExchangeRateList isSideSheetOpen={isCurrencySideBarOpen}/>
        </div>
      </SideSheet>
    </>
  );
};
